import {useIonLoading} from "@ionic/react";

export function withIonLoading(Component) {
    return function WrappedComponent(props) {
        const [presentLoading, dismissLoading] = useIonLoading();
        return <Component {...props} presentLoading={presentLoading} dismissLoading={dismissLoading} />;
    }
}